module.exports = __webpack_public_path__ + "img/民爆行业结构示意图.c71ef755.jpg";